import LogCannon from '@ace-clublabs/log-cannon';
import { IGetConfirmationRequest } from '@lib/types';
import axios from 'axios';
import StatusCode from 'status-code-enum';
import { ErrorType } from '../../shared/types';
import CookieHelper from '../../utils/cookieHelper';
import { GetConfirmation } from '../contracts';
import { createAxiosConfig } from '../mockHelper';

export const GetConfirmationApi =
  (endpoint: string): GetConfirmation =>
  async (request: IGetConfirmationRequest) => {
    try {
      const scenario = CookieHelper.getCookie('scenario');
      LogCannon.blast('GetConfirmationApi scenario', { scenario });

      LogCannon.blast('GetConfirmationApi start', {
        endpoint,
        transactionId: request.transactionId,
      });
      const response = await axios.post(endpoint, request, createAxiosConfig(scenario, endpoint));

      LogCannon.blast('GetConfirmationApi success');

      return Promise.resolve(response.data);
    } catch (error: any) {
      LogCannon.error('GetConfirmationApi error', { error: error?.message });

      const errorResponse = error?.response;
      if (errorResponse) {
        if (errorResponse.status === StatusCode.ClientErrorPaymentRequired) {
          return Promise.reject({
            message: errorResponse.data?.error?.message,
            type: ErrorType.PAYMENT_ERROR,
            clubCode: errorResponse.data?.clubCode,
          });
        } else {
          return Promise.reject({
            message: errorResponse.data?.error?.message,
            type: ErrorType.SYSTEM_ERROR,
            clubCode: errorResponse.data?.clubCode,
          });
        }
      } else {
        return Promise.reject({
          message: error,
          type: ErrorType.UNKNOWN,
        });
      }
    }
  };
